'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Tooltip;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTooltip = require('react-tooltip');

require('react-tooltip/dist/react-tooltip.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Tooltip(props) {
  var propTypes = {
    children: _propTypes2.default.node,
    content: _propTypes2.default.string,
    place: _propTypes2.default.string
  };

  var id = randomString(12);

  return _react2.default.createElement(
    'div',
    { style: { display: 'inline-block' } },
    _react2.default.createElement(
      'a',
      { className: '' + id },
      props.children
    ),
    _react2.default.createElement(_reactTooltip.Tooltip, { anchorSelect: '.' + id, content: props.content, place: props.place })
  );
}

function randomString(chars) {
  var text = '';
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  for (var i = 0; i < chars; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
}